import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import logo from "assets/images/bmd-logo.png";
import { BButton } from "components/base";
import clsx from "clsx";
import { useCallback } from "react";
import "./SidebarHeader.scss";

type SidebarHeaderProps = {
  collapsed: boolean;
  onToggleCollapse: () => void;
  onOpenSearch: () => void;
  onNavigate?: () => void;
};

const SidebarHeader = ({
  collapsed,
  onToggleCollapse,
  onOpenSearch,
  onNavigate,
}: SidebarHeaderProps) => {
  const handleToggle = useCallback(() => {
    onToggleCollapse();
  }, [onToggleCollapse]);

  const handleOpenSearch = useCallback(() => {
    onOpenSearch();
    onNavigate?.();
  }, [onOpenSearch, onNavigate]);

  return (
    <header
      className={clsx("sidebar-header", collapsed && "sidebar-header--collapsed")}
    >
      <img src={logo} alt="BMD Chat" className="sidebar-header__logo" />
      <div className="sidebar-header__actions">
        <BButton
          type="text"
          className="sidebar-header__search"
          icon={<SearchOutlined />}
          onClick={handleOpenSearch}
          aria-label="Search"
          title="Search"
        />
        <BButton
          type="text"
          className="sidebar-header__toggle"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={handleToggle}
          aria-label={collapsed ? "Mở thanh bên" : "Đóng thanh bên"}
          title={collapsed ? "Mở thanh bên" : "Đóng thanh bên"}
        />
      </div>
    </header>
  );
};

export default SidebarHeader;
